if (!customElements.get('variant-options')) {
    let urlCheckCount = 0;
    const urlCheckCountMax = 500;
    const urlCheckInterval = 50; // milliseconds
    let urlCheckFinished = false;
    let urlVariantInterval = null;
    class VariantOptions extends HTMLElement {
        static get observedAttributes() {
            return ['test-region'];
        }
        attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'test-region') {
                if (urlCheckFinished) {
                    this.connectedCallback();
                    if (urlVariantInterval) {
                        clearInterval(urlVariantInterval);
                    }
                } else {
                    clearInterval(urlVariantInterval);
                    urlVariantInterval = setInterval(() => {
                        const urlVariant = new URL(
                            window.location
                        ).searchParams.get('variant');
                        if (
                            !urlVariant &&
                            urlCheckCount <= urlCheckCountMax &&
                            !urlCheckFinished
                        ) {
                            urlCheckCount += urlCheckInterval;
                        } else {
                            urlCheckFinished = true;
                            clearInterval(urlVariantInterval);
                            this.connectedCallback();
                        }
                    }, urlCheckInterval);
                }
            }
        }
        async connectedCallback() {
            this.variantOptions = document.getElementById(
                'product-variant-option-json'
            )
                ? JSON.parse(
                      document.getElementById('product-variant-option-json')
                          .innerText
                  )
                : [];

            this.variantOptions = this.variantOptions.filter(
                (variant) => variant.available === true
            );

            if (!this.variantOptions) {
                return;
            }

            await new Promise((resolve) => requestAnimationFrame(resolve));

            const variantOptionRowOne = this.querySelector(
                'variant-option-row-one'
            );

            if (variantOptionRowOne) {
                this.isTestRegion = this.getAttribute('test-region');
                this.variantOptionRowOne = variantOptionRowOne || undefined;
                this.variantOptionRowTwo =
                    this.querySelector('variant-option-row-two') || undefined;
                this.variantOptionRowThree =
                    this.querySelector('variant-option-row-three') || undefined;
                this.selectedVariant =
                    new URLSearchParams(location.search).get('variant') ||
                    variant?.id;

                const urlParams = new URLSearchParams(window.location.search);
                this.currentSelectedVariant = urlParams.get('variant') || '';
                this.parentSelectedVariant = this.getParentVariant();
                this.moneyFormatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });

                this.renderVariantOptionThreeRow();
                this.renderVariantOptionTwoRow();
                this.renderVariantOptionOneRow();
                this.bindEvents();
            }

            document.dispatchEvent(new CustomEvent('packs_rendered', {}));
            window.packsDidRender = true;
        }

        // bind events
        bindEvents() {
            this.onSourceVariantChange();
            this.onOptionTwoRowVariantChange();
        }

        getParentVariant() {
            let __selectedVariant = this.selectedVariant;
            let __filterParentVariants = this.variantOptions.filter(
                (variant) => Number(variant.id) !== Number(__selectedVariant)
            );
            let __qtyOptions = [],
                __potOptions;
            let __parentVariants =
                __filterParentVariants.filter((option) => {
                    if (option?.quantity_options?.length > 0) {
                        __qtyOptions = option.quantity_options.filter(
                            (qtyOpt) =>
                                Number(__selectedVariant) ===
                                Number(qtyOpt.variant_id)
                        );
                    }
                    if (__qtyOptions.length === 0) {
                        if (option?.pot_options?.length > 0) {
                            __potOptions = option.pot_options.filter(
                                (qtyOpt) =>
                                    Number(__selectedVariant) ===
                                    Number(qtyOpt.variant_id)
                            );
                        }
                    }
                    return __potOptions?.length > 0 || __qtyOptions.length > 0
                        ? true
                        : false;
                }) || [];

            return __parentVariants?.length > 0
                ? __parentVariants[0]?.id
                : __selectedVariant;
        }

        getParentElement(childElement, parentSelector) {
            if (childElement.matches(parentSelector)) {
                return childElement;
            } else if (childElement.parentElement) {
                return this.getParentElement(
                    childElement.parentElement,
                    parentSelector
                );
            } else {
                return null;
            }
        }
        #checkNestedKey(obj, key) {
            if (typeof obj !== 'object') {
                return false;
            }
            if (Array.isArray(obj)) {
                for (let i = 0; i < obj.length; i++) {
                    if (this.#checkNestedKey(obj[i], key)) {
                        return true;
                    }
                }
            } else {
                if (obj?.hasOwnProperty(key)) {
                    return true;
                }
                for (let prop in obj) {
                    if (this.#checkNestedKey(obj[prop], key)) {
                        return true;
                    }
                }
            }
            return false;
        }
        variantHasDataBOGOAttribute() {
            let variantOptions = this.variantOptions;
            let isOptionHasBOGO = false;
            for (let i = 0; i < variantOptions.length; i++) {
                const firstRowVariant = variantOptions[i];
                isOptionHasBOGO = this.#checkNestedKey(
                    firstRowVariant,
                    'variants__discount_bogo'
                );
                if (isOptionHasBOGO === true) {
                    break;
                }
                // check if second row variant has BOGO attribute or not
                if (firstRowVariant?.quantity_options?.length > 0) {
                    for (
                        let i = 0;
                        i < firstRowVariant?.quantity_options?.length;
                        i++
                    ) {
                        const secondRowVariant =
                            firstRowVariant?.quantity_options[i];
                        isOptionHasBOGO = this.#checkNestedKey(
                            secondRowVariant,
                            'variants__discount_bogo'
                        );
                        if (isOptionHasBOGO === true) {
                            break;
                        }
                    }
                }
                // check if third row variant has BOGO attribute or not
                if (firstRowVariant?.pot_options?.length > 0) {
                    for (
                        let i = 0;
                        i < firstRowVariant?.pot_options?.length;
                        i++
                    ) {
                        const thirdRowVariant = firstRowVariant?.pot_options[i];
                        isOptionHasBOGO = this.#checkNestedKey(
                            thirdRowVariant,
                            'variants__discount_bogo'
                        );
                        if (isOptionHasBOGO === true) {
                            break;
                        }
                    }
                }
            }
            return isOptionHasBOGO;
        }

        onSourceVariantChange() {
            let __this = this;
            let sourceOptions = this.variantOptionRowOne.querySelectorAll(
                '.variants__list li'
            )
                ? Array.prototype.slice.call(
                      this.variantOptionRowOne.querySelectorAll(
                          '.variants__list li'
                      )
                  )
                : [];

            if (sourceOptions.length === 0) {
                return;
            }

            const urlParams = new URLSearchParams(window.location.search);
            this.currentSelectedVariant = urlParams.get('variant') || '';

            for (let index = 0; index < sourceOptions.length; index++) {
                const sourceOption = sourceOptions[index];
                sourceOption.addEventListener('click', () => {
                    const url = new URL(location);
                    if (url.searchParams.has('pack_id')) {
                        url.searchParams.delete('pack_id');
                        history.pushState({}, '', url);
                    }
                    $('#Quantity').val('1').change();

                    let _target = __this.getParentElement(
                        event.target,
                        '.variants__block--option1'
                    );
                    if (!_target) {
                        return;
                    }

                    let _variant =
                        _target.getAttribute('data-variant-id') || '';

                    this.currentSelectedVariant =
                        _variant || urlParams.get('variant');

                    _variant !== ''
                        ? __this.renderVariantOptionTwoRow(
                              _variant,
                              this.currentSelectedVariant
                          )
                        : undefined;

                    _variant !== ''
                        ? __this.renderVariantOptionThreeRow(
                              _variant,
                              this.currentSelectedVariant
                          )
                        : undefined;
                });
            }
        }

        onOptionTwoRowVariantChange() {
            let __this = this;

            let sourceOptions = this.variantOptionRowTwo.querySelectorAll(
                '.variants__list li'
            )
                ? Array.prototype.slice.call(
                      this.variantOptionRowTwo.querySelectorAll(
                          '.variants__list li'
                      )
                  )
                : [];

            if (sourceOptions.length === 0) {
                return;
            }

            const urlParams = new URLSearchParams(window.location.search);
            this.currentSelectedVariant = urlParams.get('variant') || '';

            for (let index = 0; index < sourceOptions.length; index++) {
                const sourceOption = sourceOptions[index];
                sourceOption.addEventListener('click', () => {
                    // TODO: Optimize this, I think it's going to check the whole DOM multiple times
                    let _target = __this.getParentElement(
                        event.target,
                        '.variants__block--option2'
                    );

                    if (!_target) {
                        return;
                    }

                    const packId = _target.getAttribute('data-pack-id');
                    const url = new URL(location);
                    $('#Quantity').val('1').change();
                    if (packId) {
                        url.searchParams.set('pack_id', packId);
                        history.pushState({}, '', url);
                    } else if (url.searchParams.has('pack_id')) {
                        url.searchParams.delete('pack_id');
                        history.pushState({}, '', url);
                    }

                    let _variant =
                        _target.getAttribute('data-parent-variant') || '';

                    this.currentSelectedVariant =
                        _variant || urlParams.get('variant');

                    _variant !== ''
                        ? __this.renderVariantOptionThreeRow(_variant)
                        : undefined;
                });
            }
        }

        /**
         * Returns packsDiscounts with/without non-feed packs, depending on test group
         * @param {string} packsDiscounts
         * @returns {string}
         */
        getFinalPacksDiscounts(packsDiscounts) {
            return (packsDiscounts || '')
                .split('|')
                .map((pd) => pd.split(','))
                .filter(([, , isIncludedInFeed]) => {
                    if (pmpABTestingV1.isUserInGroup('Test')) return true;
                    return isIncludedInFeed !== '0';
                })
                .map((pd) => pd.join(','))
                .join('|');
        }

        renderVariantOptionOneRow() {
            let __variantOptions = this.variantOptions;
            let existingSize = [],
                optionItems = [];
            const isDiscountDollarsExperiment =
                JSON.parse(localStorage.getItem('active_experiments'))[
                    'PDP Compare Price Discount As Dollars vs Percent V1'
                ] === 'Test';
            const isRegionPriceBucketOrTestRegion =
                localStorage.getItem('region_price_bucket_enabled') ===
                    'true' || this.isTestRegion === true;

            for (let index = 0; index < __variantOptions.length; index++) {
                const __variantOption = __variantOptions[index];
                let optionTitle =
                    __variantOption?.option_title.trim() !== ''
                        ? __variantOption?.option_title.trim()
                        : __variantOption?.variant_title.trim();
                const isNotPack =
                    __variantOption?.option_type?.toLowerCase() !== 'pack';

                if (!existingSize.includes(optionTitle)) {
                    optionItems.push(`
                        <li class="${
                            this.variantHasDataBOGOAttribute() === true
                                ? 'variants__has-BOGO '
                                : ''
                        }variants__block ${
                        __variantOption?.id ===
                        Number(this.parentSelectedVariant)
                            ? `variants__block--active`
                            : ''
                    } ${
                        !__variantOption?.available
                            ? 'variants__block--soldOut'
                            : ''
                    } variants__block--option1"
                    data-packs-discounts="${this.getFinalPacksDiscounts(
                        __variantOption?.packs_discounts
                    )}"
                            ${this.createDataAttributes(__variantOption, true)}
                            <span class="variant__title">${optionTitle}</span>
                            ${
                                __variantOption?.available === false
                                    ? `<span class="variants__price">Out of Stock</span>`
                                    : ''
                            }
                            ${
                                __variantOption?.region_price &&
                                __variantOption?.available === true &&
                                isRegionPriceBucketOrTestRegion
                                    ? `<div class="variants__price region_variant_price visually-hidden">
                                            ${
                                                __variantOption?.region_compare_at_price >
                                                __variantOption?.region_price
                                                    ? `<span class="main__region-price sale__price">${
                                                          __variantOption?.region_price_money
                                                      }</span><span class="region__compare-price compare__price">${this.moneyFormatter.format(
                                                          __variantOption?.region_compare_at_price
                                                      )}</span>`
                                                    : `<span class="main__region-price">${__variantOption?.region_price_money}</span>`
                                            }
                                        </div>`
                                    : __variantOption?.available === true
                                    ? `<div class="variants__price visually-hidden">
                                        ${
                                            __variantOption?.compare_at_price >
                                            __variantOption?.price
                                                ? `<span class="main__price sale__price">${__variantOption?.price_money}</span><span class="main__compare-price compare__price">${__variantOption?.compare_at_price_money}</span>`
                                                : `<span class="main__price">${__variantOption?.price_money}</span>`
                                        }
                                      </div>`
                                    : ''
                            }
                            ${
                                this.isRegionDiscountBadgeVisible(
                                    __variantOption,
                                    isRegionPriceBucketOrTestRegion
                                ) && isNotPack
                                    ? `<span class="variants__discount region_discount_bubble">${__variantOption?.variants__discount_region}</span>`
                                    : this.isNormalDiscountBadgeVisible(
                                          __variantOption,
                                          isRegionPriceBucketOrTestRegion
                                      ) && isNotPack
                                    ? `<span class="variants__discount">${__variantOption?.variants__discount}</span>`
                                    : ''
                            }
                            ${
                                __variantOption?.variants__discount_bogo &&
                                __variantOption?.available === true &&
                                isNotPack
                                    ? `<span class="variants__discount variants__discount--bogo">${__variantOption?.variants__discount_bogo}</span>`
                                    : ''
                            }
                            ${this.createVariantDiscountBubble(
                                __variantOption,
                                isDiscountDollarsExperiment,
                                this.isRegionDiscountBadgeVisible(
                                    __variantOption,
                                    isRegionPriceBucketOrTestRegion
                                ),
                                this.isNormalDiscountBadgeVisible(
                                    __variantOption,
                                    isRegionPriceBucketOrTestRegion
                                ),
                                isNotPack
                            )}
                        </li>
                    `);
                    existingSize.push(optionTitle);
                }
            }
            this.variantOptionRowOne.innerHTML =
                optionItems.length > 0
                    ? `<div class="product__variants">
                    <div class="variants__label test">Select size <a href="#size-comparison-modal" rel="modal:open" class="size-comp visually-hidden">Size comparison</a></div>
                    <div id="size-comparison-modal" class="modal" style="display: none;">
                        <div class="modal__title">Size comparison</div>
                    </div>
                    <ul class="variants__list">
                        ${optionItems.join('')}
                    </ul>
                </div>
                `
                    : '';
        }

        // @param selectedVariantID {String} SKU of Selected Size (AKA Single)
        // @param currentSelectedVariant {String} SKU of Selected Pack, default: Single
        renderVariantOptionTwoRow(
            selectedVariantId = this.parentSelectedVariant,
            currentSelectedVariant = this.currentSelectedVariant
        ) {
            let __variantOptions = this.variantOptions.filter(
                (option) => option.available === true
            );
            let hasOptionOnlySingleQty =
                // When we only have a single available, we don't show the second row
                // We pre-populate availableOptions with a Single, so Single is the only option if its' length is not greater than 1
                __variantOptions.filter((option) => {
                    let availableOptions = option?.quantity_options?.filter(
                        (qtyOption) => qtyOption.available === true
                    );
                    return availableOptions?.length > 1;
                }).length === 0;
            __variantOptions = this.variantOptions.filter(
                // this.variantOptions includes all sizes like 1-2ft, 3-4ft, etc. We filter for our current size and then render off of quantity_options
                (option) => Number(option.id) === Number(selectedVariantId)
            );

            const isDiscountDollarsExperiment =
                JSON.parse(localStorage.getItem('active_experiments'))[
                    'PDP Compare Price Discount As Dollars vs Percent V1'
                ] === 'Test';
            const isPricePerTreePackExperiment = false;
            const isRegionPriceBucketOrTestRegion =
                localStorage.getItem('region_price_bucket_enabled') ===
                    'true' || this.isTestRegion === true;

            let optionItems = [];

            if (__variantOptions?.length === 0) {
                this.variantOptionRowTwo.innerHTML = '';
                return;
            }

            for (let index = 0; index < __variantOptions.length; index++) {
                const __variantOption = __variantOptions[index];
                const isPack =
                    __variantOption?.option_type?.toLowerCase() === 'pack';

                // __variantOption.quantity_options represents packs of the currently selected size variant
                let quantity_options = __variantOption?.quantity_options
                    ?.filter((option) => option.available === true)
                    .sort(function (a, b) {
                        return (
                            Number(a.option_quantity_value) -
                            Number(b.option_quantity_value)
                        );
                    });

                const finalPacksDiscounts = this.getFinalPacksDiscounts(
                    __variantOption?.packs_discounts
                );
                const isPMPEnabled =
                    finalPacksDiscounts && quantity_options?.length > 0;

                if (hasOptionOnlySingleQty === true && !isPMPEnabled) {
                    this.variantOptionRowTwo.innerHTML = '';
                    return;
                }

                if (isPMPEnabled) {
                    // take just the first option, which is the Single, then add on our pack options
                    quantity_options = quantity_options.slice(0, 1);
                    const packs_discounts = finalPacksDiscounts
                        .split('|')
                        .map((pd) => pd.split(','))
                        .map(([packSize, discountPercent]) => [
                            parseFloat(packSize),
                            parseFloat(discountPercent),
                        ]);
                    packs_discounts.forEach(([packSize, discountPercent]) => {
                        const singleClone = { ...quantity_options[0] };
                        const discountDecimal =
                            Math.round((1 - discountPercent / 100) * 100) / 100; // 33 -> .67
                        const packPrice =
                            singleClone.price * packSize * discountDecimal;
                        const money_packPrice = this.moneyFormatter.format(
                            packPrice / 100
                        );
                        const packComparePrice =
                            singleClone.compare_at_price * packSize;
                        const regionPackPrice =
                            (singleClone.region_price_opt ||
                                singleClone.price ||
                                0) *
                            packSize *
                            discountDecimal;
                        const regionPackComparePrice =
                            (singleClone.region_compare_at_price
                                ? parseFloat(
                                      singleClone.region_compare_at_price
                                  ) * 100
                                : singleClone.compare_at_price || 0) * packSize;
                        const money_regionPackPrice =
                            this.moneyFormatter.format(regionPackPrice / 100);
                        const normal_percentage_off = `${Math.round(
                            (1 - packPrice / packComparePrice) * 100
                        )}% OFF`;
                        const region_discount = `${Math.round(
                            (1 - regionPackPrice / regionPackComparePrice) * 100
                        )}% OFF`;
                        const newQuantityOption = {
                            ...singleClone,
                            option_title: `${packSize}-Pack`,
                            option_type: 'Pack',
                            option_quantity_value: packSize,
                            price: packPrice,
                            price_money: money_packPrice,
                            compare_at_price: packComparePrice,
                            compare_at_price_money: this.moneyFormatter.format(
                                packComparePrice / 100
                            ),
                            region_price_opt: regionPackPrice,
                            region_price: money_regionPackPrice.replace(
                                '$',
                                ''
                            ),
                            region_price_money: money_regionPackPrice,
                            region_compare_at_price: this.moneyFormatter
                                .format(regionPackComparePrice / 100)
                                .replace('$', ''),

                            normal_percentage_off,
                            region_discount,

                            normal_dollars_off: `SAVE ${this.moneyFormatter
                                .format(
                                    Math.floor(
                                        (packComparePrice - packPrice) / 100
                                    )
                                )
                                .replace('.00', '')}`,
                            region_dollars_off: `SAVE ${this.moneyFormatter
                                .format(
                                    Math.floor(
                                        (regionPackComparePrice -
                                            regionPackPrice) /
                                            100
                                    )
                                )
                                .replace('.00', '')}`,
                            variants__discount: normal_percentage_off,
                            variants__discount_region: region_discount,
                        };
                        quantity_options.push(newQuantityOption);
                    });
                }

                // now that we have our list of packs that -are- available, iterate over them
                if (quantity_options?.length > 0) {
                    for (let x = 0; x < quantity_options.length; x++) {
                        const __variantOptionQuantity = quantity_options[x]; // example: Single, 2-pack, 4-pack

                        // I'm not sure what opt stands for but this is a raw number price in cents; aka $10 would be 1000
                        let _price =
                            __variantOptionQuantity?.region_price_opt &&
                            isRegionPriceBucketOrTestRegion
                                ? Number(
                                      __variantOptionQuantity?.region_price_opt
                                  )
                                : Number(__variantOptionQuantity?.price);
                        let _finalPrice =
                            // option_quantity_value will only be defined for variants that are packs; example: 2, 4
                            (__variantOptionQuantity?.option_quantity_value
                                ? (_price /
                                      // since we're dividing it by the pack size, _finalPrice represents price per item
                                      Number(
                                          __variantOptionQuantity?.option_quantity_value
                                      )) |
                                  0
                                : _price) / 100;

                        let isActive = false;
                        if (isPMPEnabled) {
                            const urlPackId = new URLSearchParams(
                                window.location.search
                            ).get('pack_id');
                            isActive = urlPackId
                                ? urlPackId.includes(
                                      `-${__variantOptionQuantity.option_quantity_value}PACK`
                                  )
                                : x === 0;
                        } else {
                            isActive =
                                (!currentSelectedVariant && x === 0) ||
                                Number(currentSelectedVariant) ===
                                    __variantOptionQuantity?.variant_id;
                        }

                        optionItems.push(`
                            <li data-parent-variant="${
                                __variantOption.id
                            }" class="${
                            this.variantHasDataBOGOAttribute() === true
                                ? 'variants__has-BOGO '
                                : ''
                        }variants__block ${
                            isActive ? 'variants__block--active' : ''
                        } ${
                            !__variantOptionQuantity?.available
                                ? 'variants__block--soldOut'
                                : ''
                        } variants__block--option2"
                        ${
                            __variantOption.packs_discounts &&
                            __variantOptionQuantity?.option_quantity_value
                                ? `data-pack-id="${__variantOption.id}-${__variantOptionQuantity?.option_quantity_value}PACK"
                                   data-pack-size="${__variantOptionQuantity?.option_quantity_value}"`
                                : ''
                        }
                                data-packs-discounts="${finalPacksDiscounts}"
                                ${this.createDataAttributes(
                                    __variantOptionQuantity,
                                    false
                                )}
                                <span class="variant__title">${
                                    __variantOptionQuantity?.option_title ||
                                    __variantOptionQuantity?.variant_title
                                }</span>

                                ${
                                    __variantOptionQuantity?.available === false
                                        ? `<span class="variants__price">Out of Stock</span>`
                                        : ''
                                }
                                ${
                                    __variantOptionQuantity?.available === true
                                        ? `<div class="variants__price
                                          ${isPack ? 'pack__price' : ''}
                                          ${
                                              !isPricePerTreePackExperiment
                                                  ? ' visually-hidden'
                                                  : ''
                                          }
                                          ${
                                              __variantOptionQuantity?.region_price &&
                                              isRegionPriceBucketOrTestRegion
                                                  ? ' region_variant_price'
                                                  : ''
                                          }">
                                          ${this.moneyFormatter.format(
                                              _finalPrice
                                          )}/ea</div>`
                                        : ''
                                }
                                ${
                                    this.isRegionDiscountBadgeVisible(
                                        __variantOptionQuantity,
                                        isRegionPriceBucketOrTestRegion
                                    )
                                        ? `<span class="variants__discount region_discount_bubble">${__variantOptionQuantity?.variants__discount_region}</span>`
                                        : this.isNormalDiscountBadgeVisible(
                                              __variantOptionQuantity,
                                              isRegionPriceBucketOrTestRegion
                                          )
                                        ? `<span class="variants__discount">${__variantOptionQuantity?.variants__discount}</span>`
                                        : ''
                                }
                                ${
                                    __variantOptionQuantity?.variants__discount_bogo &&
                                    __variantOptionQuantity?.available === true
                                        ? `<span class="variants__discount variants__discount--bogo">${__variantOptionQuantity?.variants__discount_bogo}</span>`
                                        : ''
                                }
                                ${this.createVariantDiscountBubble(
                                    __variantOptionQuantity,
                                    isDiscountDollarsExperiment,
                                    this.isRegionDiscountBadgeVisible(
                                        __variantOptionQuantity,
                                        isRegionPriceBucketOrTestRegion
                                    ),
                                    this.isNormalDiscountBadgeVisible(
                                        __variantOptionQuantity,
                                        isRegionPriceBucketOrTestRegion
                                    )
                                )}
                            </li>
                        `);
                    }
                }
            }
            this.variantOptionRowTwo.innerHTML =
                optionItems.length > 0
                    ? `<div class="product__variants">
                    <div class="variants__label test">Select quantity</div>
                    <ul class="variants__list">
                        ${optionItems.join('')}
                    </ul>
                </div>
                `
                    : '';
            optionItems.length > 0
                ? this.variantOptionRowTwo.removeAttribute('style')
                : undefined;
            this.onOptionTwoRowVariantChange();
        }

        renderVariantOptionThreeRow(
            selectedVariantId = this.parentSelectedVariant,
            currentSelectedVariant = this.currentSelectedVariant
        ) {
            let __variantOptions = this.variantOptions.filter(
                (option) => option.available === true
            );
            let hasOptionOnlySingleQty =
                __variantOptions.filter((option) => {
                    let availableOptions = option?.pot_options?.filter(
                        (potOption) => potOption.available === true
                    );
                    return availableOptions?.length > 1;
                }).length === 0;
            __variantOptions = this.variantOptions.filter(
                (option) => Number(option.id) === Number(selectedVariantId)
            );

            let optionItems = [];

            const isDiscountDollarsExperiment =
                JSON.parse(localStorage.getItem('active_experiments'))[
                    'PDP Compare Price Discount As Dollars vs Percent V1'
                ] === 'Test';
            const isRegionPriceBucketOrTestRegion =
                localStorage.getItem('region_price_bucket_enabled') ===
                    'true' || this.isTestRegion === true;

            if (__variantOptions?.length === 0) {
                this.variantOptionRowThree.innerHTML = '';
                return;
            }

            for (let index = 0; index < __variantOptions.length; index++) {
                const __variantOption = __variantOptions[index];
                let pot_options = __variantOption?.pot_options?.filter(
                    (option) => option.available === true
                );

                if (hasOptionOnlySingleQty === true) {
                    this.variantOptionRowThree.innerHTML = '';
                    return;
                }

                if (pot_options?.length > 0) {
                    for (let x = 0; x < pot_options.length; x++) {
                        const __variantPotOption = pot_options[x];
                        let _price =
                            __variantPotOption?.region_price &&
                            __variantPotOption?.available === true
                                ? __variantPotOption?.region_price * 100
                                : __variantPotOption?.available === true
                                ? __variantPotOption?.price
                                : 0;

                        let _finalPrice = _price / 100;

                        optionItems.push(`
                            <li data-parent-variant="${
                                __variantOption.id
                            }" class="${
                            this.variantHasDataBOGOAttribute() === true
                                ? 'variants__has-BOGO '
                                : ''
                        }variants__block ${
                            (!currentSelectedVariant && x === 0) ||
                            Number(currentSelectedVariant) ===
                                __variantPotOption?.variant_id
                                ? `variants__block--active`
                                : ''
                        } ${
                            !__variantPotOption?.available
                                ? 'variants__block--soldOut'
                                : ''
                        } variants__block--option3"
                            ${this.createDataAttributes(
                                __variantPotOption,
                                false
                            )}
                                    <span class="variant__title">${
                                        __variantPotOption?.option_title ||
                                        __variantPotOption?.variant_title
                                    }</span>

                                ${
                                    __variantPotOption?.available === false
                                        ? `<span class="variants__price">Out of Stock</span>`
                                        : ''
                                }

                                ${
                                    __variantPotOption?.option_title?.toLowerCase() ===
                                    'no pot'
                                        ? __variantPotOption?.region_price &&
                                          __variantPotOption?.available ===
                                              true &&
                                          isRegionPriceBucketOrTestRegion
                                            ? `<div class="visually-hidden variants__price region_variant_price">${this.moneyFormatter.format(
                                                  _finalPrice
                                              )}</div>`
                                            : __variantPotOption?.available ===
                                              true
                                            ? `<div class="visually-hidden variants__price">${this.moneyFormatter.format(
                                                  _finalPrice
                                              )}</div>`
                                            : ''
                                        : __variantPotOption?.region_price &&
                                          __variantPotOption?.available ===
                                              true &&
                                          isRegionPriceBucketOrTestRegion
                                        ? `<div class="visually-hidden variants__price region_variant_price">${this.moneyFormatter.format(
                                              _finalPrice
                                          )}</div>`
                                        : __variantPotOption?.available === true
                                        ? `<div class="visually-hidden variants__price">${this.moneyFormatter.format(
                                              _finalPrice
                                          )}</div>`
                                        : ''
                                }
                                ${
                                    this.isRegionDiscountBadgeVisible(
                                        __variantPotOption,
                                        isRegionPriceBucketOrTestRegion
                                    )
                                        ? `<span class="variants__discount region_discount_bubble">${__variantPotOption?.variants__discount_region}</span>`
                                        : this.isNormalDiscountBadgeVisible(
                                              __variantPotOption,
                                              isRegionPriceBucketOrTestRegion
                                          )
                                        ? `<span class="variants__discount">${__variantPotOption?.variants__discount}</span>`
                                        : ''
                                }
                                ${
                                    __variantPotOption?.variants__discount_bogo &&
                                    __variantPotOption?.available === true
                                        ? `<span class="variants__discount variants__discount--bogo">${__variantPotOption?.variants__discount_bogo}</span>`
                                        : ''
                                }
                                ${this.createVariantDiscountBubble(
                                    __variantPotOption,
                                    isDiscountDollarsExperiment,
                                    this.isRegionDiscountBadgeVisible(
                                        __variantPotOption,
                                        isRegionPriceBucketOrTestRegion
                                    ),
                                    this.isNormalDiscountBadgeVisible(
                                        __variantPotOption,
                                        isRegionPriceBucketOrTestRegion
                                    )
                                )}
                            </li>
                        `);
                    }
                }
            }
            this.variantOptionRowThree.innerHTML =
                optionItems.length > 0
                    ? `<div class="product__variants">
                    <div class="variants__label test">Select pot</div>
                    <ul class="variants__list">
                        ${optionItems.join('')}
                    </ul>
                </div>
                `
                    : '';
            optionItems.length > 0
                ? this.variantOptionRowThree.removeAttribute('style')
                : undefined;
        }

        isRegionDiscountBadgeVisible(option, isRegionPriceBucketOrTestRegion) {
            function stripMoney(formattedString) {
                return (formattedString || '').replace(/[\$,]/g, '');
            }
            const region_price = stripMoney(option?.region_price);
            const region_compare_at_price = stripMoney(
                option?.region_compare_at_price
            );
            return (
                !option.variants__discount_bogo &&
                option?.available &&
                isRegionPriceBucketOrTestRegion &&
                option?.variants__discount_region &&
                parseFloat(region_price) &&
                parseFloat(region_compare_at_price) > parseFloat(region_price)
            );
        }

        isNormalDiscountBadgeVisible(option, isRegionPriceBucketOrTestRegion) {
            return (
                !option.variants__discount_bogo &&
                option?.available &&
                ((isRegionPriceBucketOrTestRegion &&
                    !parseFloat(option?.region_price)) ||
                    !isRegionPriceBucketOrTestRegion) &&
                option?.compare_at_price &&
                option?.price &&
                option?.variants__discount &&
                option?.compare_at_price > option?.price
            );
        }

        createVariantDiscountBubble(
            option,
            isDiscountDollarsExperiment,
            isRegionDiscountBadgeVisible,
            isNormalDiscountBadgeVisible,
            isBubbleVisible = true
        ) {
            if (isBubbleVisible === false || option?.available !== true) {
                return '';
            }

            if (isDiscountDollarsExperiment) {
                if (
                    isRegionDiscountBadgeVisible &&
                    option?.region_dollars_off
                ) {
                    return `<span class="variants__discount region_discount_bubble">${option?.region_dollars_off}</span>`;
                } else if (
                    isNormalDiscountBadgeVisible &&
                    option?.normal_dollars_off
                ) {
                    return `<span class="variants__discount">${option?.normal_dollars_off}</span>`;
                } else {
                    return '';
                }
            } else {
                if (
                    isRegionDiscountBadgeVisible &&
                    option?.variants__discount_region
                ) {
                    return `<span class="variants__discount region_discount_bubble">${option?.variants__discount_region}</span>`;
                } else if (
                    isNormalDiscountBadgeVisible &&
                    option?.variants__discount
                ) {
                    return `<span class="variants__discount">${option?.variants__discount}</span>`;
                } else {
                    return '';
                }
            }
        }

        createDataAttributes(option, isRowOne) {
            const attributes = [
                {
                    key: isRowOne ? 'id' : 'variant_id',
                    attribute: 'data-value',
                },
                {
                    key: 'sku',
                    attribute: 'data-sku',
                },
                {
                    key: isRowOne ? 'id' : 'variant_id',
                    attribute: 'data-variant-id',
                },
                {
                    key: 'price_money',
                    attribute: 'data-variant-price',
                },
                {
                    key: 'compare_at_price_money',
                    attribute: 'data-compare-at-price',
                },
                {
                    key: 'normal_percentage_off',
                    attribute: 'data-normal-percentage-off',
                },
                {
                    key: 'variants__discount_bogo',
                    attribute: 'data-bogo',
                },
                {
                    key: 'normal_dollars_off',
                    attribute: 'data-normal-dollars-off',
                },
                { key: 'region_price', attribute: 'data-region-price' },
                {
                    key: 'region_dollars_off',
                    attribute: 'data-region-dollars-off',
                },
                {
                    key: 'region_compare_at_price',
                    attribute: 'data-region-compare-price',
                },
            ];

            let dataAttributes = '';

            for (const attr of attributes) {
                if (option && attr.key in option && option[attr.key]) {
                    dataAttributes += `${attr.attribute}="${
                        option[attr.key]
                    }" `;
                }
            }

            dataAttributes += option?.region_discount
                ? `data-region-discount="${option.region_discount}">`
                : '>';

            return dataAttributes.trim();
        }
    }

    customElements.define('variant-options', VariantOptions);
}
document.addEventListener('region_price_applied', (event) => {
    const { detail } = event;
    const newVariantSelector = document.getElementById(
        'product-variant-swatch-new'
    );
    newVariantSelector &&
        newVariantSelector.setAttribute(
            'test-region',
            detail.region_price_bucket_enabled
        );
});
